import React from "react";
import "./AboutValues.css";

import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import GroupsIcon from "@mui/icons-material/Groups";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

const values = [
  {
    icon: <AutoAwesomeIcon />,
    title: "Innovation First",
    text: "We embrace modern technologies and creative thinking to build future-ready digital solutions.",
  },
  {
    icon: <VisibilityIcon />,
    title: "Transparency",
    text: "Clear communication, honest processes, and complete visibility at every stage of engagement.",
  },
  {
    icon: <VerifiedUserIcon />,
    title: "Quality & Security",
    text: "We deliver reliable, secure, and scalable solutions that meet global quality standards.",
  },
  {
    icon: <GroupsIcon />,
    title: "Client Partnership",
    text: "We work as an extension of our clients’ teams, focusing on long-term success.",
  },
  {
    icon: <TrendingUpIcon />,
    title: "Scalable Growth",
    text: "Our solutions are designed to grow with your business and adapt to future needs.",
  },
];

const AboutValues = () => {
  return (
    <section className="oglitz-about-values-dark">
      <div className="oglitz-about-values-header">
        <span className="oglitz-about-values-accent"></span>
        <h2>Our Core Values</h2>
        <p>
          The principles that guide our work, shape our culture, and define how
          we deliver value to our clients.
        </p>
      </div>

      <div className="oglitz-about-values-grid">
        {values.map((item, index) => (
          <div className="oglitz-about-values-card-dark" key={index}>
            <div className="oglitz-about-values-icon-dark">{item.icon}</div>

            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutValues;
